// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3f-CP","col":"styles_col__2WCnO","actions":"styles_actions__1dP6v","conflict":"styles_conflict__3X4Co"};